import type { CSSProperties, ReactNode } from 'react';

const BUBBLE_SHADOW =
    '-0.25px -0.25px 0px 0px rgba(0, 0, 0, 0.05), 0px 0px 1px 0px rgba(66, 66, 66, 0.11), 0px 0px 1px 0px rgba(66, 66, 66, 0.07), 0px 0px 1px 0px rgba(66, 66, 66, 0.02), inset -0.5px -0.5px 1px 0px rgba(0, 0, 0, 0.07), inset 1px 1px 1px 0px rgba(251, 251, 255, 0.75), inset 0px 0px 1px 0px rgba(66, 66, 66, 0)';

const BUBBLE_STYLE: CSSProperties = {
    animationFillMode: 'both',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    boxShadow: BUBBLE_SHADOW,
};

export type UserBubbleProps = {
    readonly children: ReactNode;
    readonly timestamp?: number;
    readonly timeFormatter?: Intl.DateTimeFormat;
    readonly compact?: boolean;
};

export function UserBubble({ children, timestamp, timeFormatter, compact }: UserBubbleProps) {
    return (
        <div className="group flex w-full flex-col items-end">
            <div
                className="max-w-[85%] animate-slide-up-fade rounded-xl bg-gray-400 px-xl py-l text-xs text-black-900"
                style={BUBBLE_STYLE}
            >
                <div className={`m-0 whitespace-pre-wrap ${compact ? 'text-xxs' : 'text-xs'} text-black-900`}>
                    {children}
                </div>
            </div>
            {timestamp !== undefined && timeFormatter && (
                <p className="m-0 mt-xxs text-[11px] text-gray-600 opacity-0 transition-opacity duration-150 group-hover:opacity-100">
                    {timeFormatter.format(new Date(timestamp))}
                </p>
            )}
        </div>
    );
}
